(() => {
  if (window.baTokyoReviewPlacementMounted) return;
  window.baTokyoReviewPlacementMounted = true;

  const wrapperId = "trustpilot-widget-trustbox-0-wrapper";
  const styles = {
    position: "relative",
    inset: "auto",
    "z-index": "0",
    "margin-inline": "auto",
    width: "min(300px, 100%)",
  };
  let discoveryObserver;
  let discoveryTimeout;
  let styleObserver;
  let observedWrapper;

  const stopDiscovery = () => {
    discoveryObserver?.disconnect();
    discoveryObserver = null;
    window.clearTimeout(discoveryTimeout);
    discoveryTimeout = null;
  };

  const cleanup = () => {
    stopDiscovery();
    styleObserver?.disconnect();
    styleObserver = null;
    observedWrapper = null;
  };

  const placeReview = () => {
    const wrapper = document.getElementById(wrapperId);
    const footer = document.querySelector("footer.footer");
    if (!wrapper || !footer) return false;

    if (!footer.contains(wrapper)) footer.append(wrapper);
    for (const [property, value] of Object.entries(styles)) {
      if (wrapper.style.getPropertyValue(property) !== value || wrapper.style.getPropertyPriority(property) !== "important") {
        wrapper.style.setProperty(property, value, "important");
      }
    }

    if (observedWrapper !== wrapper) {
      styleObserver?.disconnect();
      observedWrapper = wrapper;
      styleObserver = new MutationObserver(placeReview);
      styleObserver.observe(wrapper, { attributes: true, attributeFilter: ["style"] });
    }
    return true;
  };

  const initialize = () => {
    cleanup();
    if (!document.body || placeReview()) return;

    discoveryObserver = new MutationObserver(() => {
      if (placeReview()) stopDiscovery();
    });
    discoveryObserver.observe(document.body, { childList: true });
    discoveryTimeout = window.setTimeout(stopDiscovery, 60000);
  };

  window.addEventListener("pagehide", () => {
    document.removeEventListener("DOMContentLoaded", initialize);
    cleanup();
  });
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) initialize();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
